export { Skeleton as FormSkeleton } from './Skeleton';
